<template>
	<div class="eta-md zeta-lg">
		<DataTableRow>
			<DataTableCell :is-title="true" :class="{ 'flex-1': isMobile }">{{ navText }} </DataTableCell>
			<DataTableCell
				v-for="(month, i) in props.monthlyReturns"
				:key="month.monthOrdinal"
				class="reit-historical-performance"
				:class="{ 'reit-historical-performance-quarter-end': (i + 1) % 3 === 0 }"
			>
				{{ currency(month.navAtMonthEnd) }}
			</DataTableCell>
		</DataTableRow>
		<DataTableRow>
			<DataTableCell :is-title="true" :class="{ 'flex-1': isMobile }">Distribution rate</DataTableCell>
			<DataTableCell
				v-for="(month, i) in props.monthlyReturns"
				:key="month.monthOrdinal"
				class="reit-historical-performance"
				:class="{ 'reit-historical-performance-quarter-end': (i + 1) % 3 === 0 }"
			>
				{{ formattedPerformancePercentageValue(month.dividendReturn, true, true) }}
			</DataTableCell>
		</DataTableRow>
		<DataTableRow>
			<DataTableCell :is-title="true" :class="{ 'flex-1': isMobile }">Appreciation </DataTableCell>
			<DataTableCell
				v-for="(month, i) in props.monthlyReturns"
				:key="month.monthOrdinal"
				class="reit-historical-performance"
				:class="{ 'reit-historical-performance-quarter-end': (i + 1) % 3 === 0 }"
			>
				{{ formattedPerformancePercentageValue(month.navReturn, true, true) }}
			</DataTableCell>
		</DataTableRow>
		<DataTableRow :is-total="true">
			<DataTableCell :is-title="true" :class="{ 'flex-1': isMobile }">Total return</DataTableCell>
			<DataTableCell
				v-for="(month, i) in props.monthlyReturns"
				:key="month.monthOrdinal"
				class="reit-historical-performance eta-mdo"
				:class="{ 'reit-historical-performance-quarter-end': (i + 1) % 3 === 0 }"
			>
				{{ formattedPerformancePercentageValue(month.totalReturn, true, true) }}
			</DataTableCell>
		</DataTableRow>
	</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { currency } from '@filters/shared-filters';
import DataTableCell from '@components/account/data-table-cell.vue';
import DataTableRow from '@components/account/data-table-row.vue';
import { formattedPerformancePercentageValue } from '@utils/performance-portfolio';
import { FundPerformanceForMonth } from 'types/reit-details';
import { useAppStore } from '@stores/app';

interface Props {
	monthlyReturns: Array<FundPerformanceForMonth>;
}

const props = defineProps<Props>();

const appStore = useAppStore();

const isMobile = computed((): boolean => appStore.isMobile);

const navText = computed((): string => (appStore.isDesktop ? 'NAV at end of period' : 'NAV'));
</script>
